package com.example.mystybag.sharedmodels.project.responseModels.nomenclatures

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GetAllergensResponseModel(
    @SerialName("allergens")
    val allergens: List<AllergenModel> = emptyList()
) : BaseResponseModel()

@Serializable
data class AllergenModel(
    val id: Long = 0,
    val name: String = ""
)

